import { Box, Grid } from "@mui/material";

import SampleOriginDistribution from "./SampleOriginDistribution";
import ModalTrigger from "../Common/ModalTrigger";
import csv1 from "../../Data/MANCP/Geospatial/MANCP-Sample-origin-per-country-of-sampling.csv";
import HorizontalBarChart from "../Charts/HorizontalBarChart";

const SamplingRegion = (props) => {
  return (
    <Grid
      item
      container
      direction={{ xs: "column", sm: "column", md: "row" }}
      sx={{
        marginTop: { xs: "50px", sm: "50px", md: "30px" },
        textAlign: { xs: "left", sm: "center", md: "left" },
      }}
      justifyContent="center"
      alignItems="center"
    >
      <Grid
        item
        xs
        className="two-one"
        sx={{
          paddingLeft: { xs: "24px", sm: "24px", md: "24px" },
          paddingRight: { xs: "24px", sm: "45x", md: "24px" },
          paddingBottom: { xs: "24px", sm: "24px", md: "24px" },
          maxWidth: { md: "450px !important" },
        }}
      >
        <Box>
          <h3>Origin of samples</h3>
          <p className="paragraph">
            Of the 86,449 samples analysed, 50.8% were from the same reporting countries (i.e.{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="domestic samples"
            />
            ), while 15.8% came from another reporting country, and 21.0% were imported to the EU from third countries. The remaining 12.4% were reported as being of unknown origin.
          </p>
          <p className="paragraph">
            Among the 57,574 samples from reporting countries, 59.7% contained residues below the LOQ, while 38.2% contained residues at or above the LOQ but below or equal to the MRL. Additionally, 2.1% of these samples{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 1.0% were not compliant with the{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="MRL"
            />
            .
          </p>
          <p className="paragraph">
            Results showed that 42.1% of the 18,184 samples imported from third countries had no quantifiable residues, while 49.6% of samples contained quantifiable residues within the MRLs. Samples from third countries were found to have higher rates of MRL exceedance (8.3%) and{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliance"
            />{" "}
            (5.2%) than EU samples.
          </p>

          <Box display="flex" flexDirection="column">
            <SampleOriginDistribution />
          </Box>
        </Box>
      </Grid>
      <Grid
        item
        xs
        className="two-two"
        justifyContent="center"
        alignItems="center"
        sx={{
          paddingLeft: { xs: "10px", sm: "10px", md: "24px" },
          paddingRight: { xs: "40px", sm: "40px", md: "24px" },
          paddingBottom: { xs: "24px", sm: "24px", md: "24px" },
          width: "100%",
        }}
      >
        <HorizontalBarChart
          csv={csv1}
          title="Sample origin percentage per country of sampling"
          yField="country"
          xField="value"
          transform={true}
          stackField="region"
        />
      </Grid>
    </Grid>
  );
};

export default SamplingRegion;
